/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MaxLengthNumericEditor from '../../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../../SharedModules/StyleConstant/StyleConstant';
import { quarterComparator } from '../../../../../../SharedModules/DateUtilities/DateUtilities';
import { sortComparator } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
// import CheckBoxRender from "./checkBoxRender";

export const tableHead = [
  {
    headerName: 'Actions',
    field: 'action',
    filter: false,
    sortable: false,
    minWidth: Styles.Width_100,
    editable: false,
    resizable: false,
    suppressMenu: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
  },
  {
    headerName: 'Start Quarter',
    field: 'nmAccountIdVO.startQtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: quarterComparator,
    cellRenderer: 'StartQuarterTextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'File Type',
    field: 'nmAccountIdVO.fileType',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: (valueA, valueB) =>
      sortComparator(valueA.trim().toUpperCase(), valueB.trim().toUpperCase()),
    cellRenderer: 'FileTypeTextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Account number',
    field: 'nmAccountIdVO.accountNumber',
    editable: false,
    suppressMenu: false,
    sortable: true,
    comparator: (valueA, valueB) =>
      sortComparator(valueA.trim(), valueB.trim()),
    cellRenderer: 'AccountNumberTextBoxRender',
    cellEditorParams: {
      maxLength: 8,
      custWidth: '135px',
    },
    cellStyle: {
      'padding-bottom': 5,
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
